import { SearchType } from '@/types/most-search-type';

interface GetSearchModalityParams {
  searchType?: string;
  isLaboratorialSearch?: boolean;
  isVaccineSearch?: boolean;
}

export function getSearchModality({
  searchType,
  isLaboratorialSearch,
  isVaccineSearch,
}: GetSearchModalityParams): SearchType {
  if (isVaccineSearch) {
    return SearchType.VACCINE;
  }

  if (isLaboratorialSearch || searchType === SearchType.LABORATORIAL_EXAM) {
    return SearchType.LABORATORIAL_EXAM;
  }

  if (searchType === SearchType.ONLINE_CONSULTATION) {
    return SearchType.ONLINE_CONSULTATION;
  }

  return SearchType.PRESENTIAL_CONSULTATION;
}
